import { useQuery } from '@tanstack/react-query';

import axios from 'axios';
import { ExtractFnReturnType, QueryConfig } from 'lib/react-query';

import { LocationWeatherRelations } from 'types';

export const getLocationForWeatherWindow = async (
  windowId: number | undefined
): Promise<LocationWeatherRelations | undefined> => {
  if (windowId === undefined) return;
  const { data } = await axios.get(`/api/weather/windows/${windowId}/location`);
  return data as LocationWeatherRelations | undefined;
};

type QueryFnType = typeof getLocationForWeatherWindow;

type UseWeatherWindowOptions = {
  windowId: number | undefined;
  config?: QueryConfig<QueryFnType>;
};

export const useLocationForWeatherWindow = ({
  windowId,
  config,
}: UseWeatherWindowOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['weatherWindowLocations', windowId],
    queryFn: () => getLocationForWeatherWindow(windowId),
  });
};
